import axios from 'axios';
import i18n from './i18n';

const httpClient = axios.create({
  baseURL: process.env.VUE_APP_MEDIA_SERVER_URL,
  timeout: 20000,
});

axios.defaults.withCredentials = true;

httpClient.defaults.headers.common['Accept-Language'] = i18n.locale;

export default httpClient;
